import { useEffect, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

import { useRecipientsList, useToken } from 'state/airdrop/hooks'

import { Links } from 'constants/link'
import { ApprovalForm, Stepper } from 'components/features'

function Approval() {
  const token = useToken()
  const recipientList = useRecipientsList()

  const navigate = useNavigate()

  const isNoAirdropData = useMemo(() => !token || !recipientList.length, [token, recipientList])

  useEffect(() => {
    if (isNoAirdropData) {
      navigate(Links.TOKEN)
    }
  }, [isNoAirdropData])

  return (
    <>
      <Stepper />
      <ApprovalForm />
    </>
  )
}

export default Approval
